import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';

interface AvatarProps {
  name: string;
  url?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ name, url, size = 'md', className }) => {
  const initials = name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base'
  };

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={cn(
        'relative rounded-full overflow-hidden flex items-center justify-center font-medium',
        sizeClasses[size],
        !url ? 'bg-primary/10 text-primary' : '',
        className
      )}
    >
      {url ? (
        url.startsWith('data:') ? (
          <img
            src={url}
            alt={name}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.currentTarget.src = '';
              e.currentTarget.style.display = 'none';
            }}
          />
        ) : (
          <div className="bg-primary/10 text-primary w-full h-full flex items-center justify-center">
            {initials}
          </div>
        )
      ) : (
        initials
      )}
    </motion.div>
  );
};

export default Avatar;